export var liquid;
(function (liquid) {
    function renderLiquidTemplate(template, vars) {
        var result = template;
        if (vars) {
            for (var v in vars) {
                var liquidVarRegexp = new RegExp('\{\{' + v + '\}\}', 'g');
                result = result.replace(liquidVarRegexp, vars[v]);
            }
        }
        return result;
    }
    liquid.renderLiquidTemplate = renderLiquidTemplate;
})(liquid || (liquid = {}));
//# sourceMappingURL=liquid.js.map